import { useEffect, useState } from 'react';

const usePageTitle = (title) => {
  const [pageTitle, setPageTitle] = useState(null);

  useEffect(() => {
    if (title) {
      setPageTitle(title);
    }
  }, [ title ]);

  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} - MyFrolight`;
    } else {
      document.title = `MyFrolight`;
    }
  }, [ pageTitle ]);
};

export default usePageTitle;
